import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Divider, Grid, Modal, Row, Stack } from 'rsuite';
import './HomePages/home.css';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import NavDrawer from './NavDrawer';
import ugr from '@/UGRoute';
import img from './Asset 15_PNG.png';
import GlobalIcon from '@rsuite/icons/Global';
import PhoneFillIcon from '@rsuite/icons/PhoneFill';
import EmailFillIcon from '@rsuite/icons/EmailFill';
const Header = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const userdata = sessionStorage.getItem('userid');
  const [parsedData, setParsData] = useState([]); // convert JSON string to object
  useEffect(() => {
    if (userdata) {
      fetchuser();
    }
  }, [userdata]);
  const fetchuser = async () => {
    const response = await fetch(
      `${globalIP}/api/user-details?populate=*&filters[id][$eq]=${userdata}`
    );
    const json = await response.json();
    // console.log('json.data');
    // console.log(json.data[0]);
    setParsData(json.data[0]);
  };

  useEffect(() => {
    const intervalID = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(intervalID);
    };
  }, []);

  const getGreeting = () => {
    const currentHour = currentTime.getHours();
    if (currentHour < 12) {
      return 'Good Morning';
    } else if (currentHour < 18) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  };

  const formatTime = time => {
    return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };
  const handleLogout = () => {
    navigate(
      `/${ugr}/client/apptwo?Key=${sessionStorage.getItem('Key')}&id=${sessionStorage.getItem(
        'idParam'
      )}&Cat_id=${sessionStorage.getItem('Cat_id')}`
    );
    sessionStorage.clear();
  };
  const [isShowButtons, setIsShowButtons] = useState({
    ppt: false,
    filter: false,
    slideShow: true,
    SmartSearch: false,
    visualProduct: false
  });
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: {
          data: { attributes }
        }
      } = await axios.get(
        `${globalIP}/api/client-logins/${sessionStorage.getItem('user_id')}?populate=*`
      );
      setIsShowButtons(prev => ({
        ppt: attributes.downloadppt,
        filter: attributes.showfilter,
        slideShow: attributes.SlideShow == null || attributes.SlideShow == false ? false : true,
        SmartSearch:
          attributes.SmartSearch == null || attributes.SmartSearch == false ? false : true,
        visualProduct:
          attributes.visualProduct == null || attributes.visualProduct == false ? false : true
      }));
    };
    fetchData();
  }, []);
  // console.log('location.pathname');
  // console.log(location.pathname);
  const getCurrentPageName =
    location.pathname == `/${ugr}/client/product`
      ? 'ProductPage'
      : location.pathname == `/${ugr}/client/home-page`
      ? 'HomePage'
      : location.pathname == `/${ugr}/client/space-visualization`
      ? 'Visual'
      : null;
  const [activeItem, setActiveItem] = useState(
    getCurrentPageName == 'HomePage'
      ? 0
      : getCurrentPageName == 'ProductPage'
      ? 1
      : getCurrentPageName == 'Visual'
      ? 3
      : null
  );

  const handleMouseEnter = index => {
    setActiveItem(index);
  };

  const handleMouseLeave = () => {
    setActiveItem(null);
  };
  const Overlay = React.forwardRef(({ style, onClose, ...rest }, ref) => {
    const styles = {
      ...style,
      color: '#000',
      background: '#fff',
      width: 200,
      padding: 10,
      borderRadius: 4,
      position: 'absolute',
      border: '1px solid #ddd',
      boxShadow: '0 3px 6px -2px rgba(0, 0, 0, 0.6)',
      zIndex: 100000000000
    };

    return (
      <div {...rest} style={styles} ref={ref}>
        Sign by
        <hr />
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}>
          <span
            className="material-symbols-outlined"
            style={{ cursor: 'pointer' }}
            onClick={handleLogout}
          >
            logout
          </span>
          <span className="roboto-regular" style={{ fontSize: '12px' }}>
            Logout
          </span>
        </div>
      </div>
    );
  });
  const [companydata, setCompanydata] = useState('');
  const [companyDetails, setCompanyDetails] = useState({
    companyName: '',
    website: '',
    email: '',
    registrationType: '',
    contactno: '',
    address: '',
    logo: null
  });

  useEffect(() => {
    fetchcompdata();
  }, []);
  const fetchcompdata = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setCompanydata(json.data[0].attributes.Type);
    const attributes = json.data[0]?.attributes;
    if (attributes) {
      setCompanyDetails({
        companyName: attributes.cmpnm,
        website: attributes.website,
        email: attributes.email_id,
        registrationType: attributes.reg_type,
        contactno: attributes.contactno,
        address: attributes.address,
        logo: attributes.Logo.data.attributes.url
      });
    }
  };
  const [openM, setOpenM] = React.useState(false);

  const handleOpenM = value => {
    setOpenM(true);
  };
  const handleCloseM = () => setOpenM(false);
  return (
    <div>
      <Grid fluid className="header-top">
        <Row style={{ padding: '10px 30px', background: '#f9f7f4' }}>
          <Col lg={3}>
            <div style={headerstyle} className="roboto-medium header-greeting">
              {getGreeting()}{' '}
            </div>
          </Col>
          <Col lg={18} sm={21}>
            <div
              className="roboto-regular header-catalogue-name"
              style={{
                ...headerstyle,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              Welcome to {sessionStorage.getItem('C-Name')}
            </div>
          </Col>
          <Col lg={3} sm={3}>
            <div
              style={{
                ...headerstyle,
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }}
              className="header-time"
            >
              {formatTime(currentTime)}{' '}
              <span
                className="material-symbols-outlined"
                style={{ cursor: 'pointer' }}
                onClick={handleLogout}
              >
                logout
              </span>
            </div>
          </Col>
        </Row>
      </Grid>
      <div style={{ background: '#f9f7f4' }} className="header-top-changes">
        <div
          className="roboto-regular header-catalogue-name"
          style={{
            ...headerstyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          Welcome to {sessionStorage.getItem('C-Name')}
        </div>
        <div
          style={{
            ...headerstyle,
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }}
          className="header-time"
        >
          {formatTime(currentTime)}{' '}
          <span
            className="material-symbols-outlined"
            style={{ cursor: 'pointer' }}
            onClick={handleLogout}
          >
            logout
          </span>
        </div>
      </div>
      {/* <Grid fluid className="logo-top">
        <Row style={{ borderBottom: '1px solid lightgrey' }}>
          <Col lg={3}></Col>
          <Col lg={18} md={24}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Link to={`/${ugr}/client/home-page`} style={{ textDecoration: 'none' }}>
                <div className="roboto-regular logo-name" style={Logostyle}>
                  <span style={{ fontSize: '40px' }} className="roboto-medium">
                    W
                  </span>
                  illiams Sonoma <span className="roboto-light">Home</span>
                </div>
              </Link>
            </div>
          </Col>
          <Col lg={3} md={24}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px 0'
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
                onClick={() => navigate(`/${ugr}/client/my-activity`)}
              >
                <span className="material-symbols-outlined" style={{ cursor: 'pointer' }}>
                  monitoring
                </span>
                <span className="roboto-regular" style={{ fontSize: '12px' }}>
                  My Activity
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Grid> */}
      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '0 10px',
          position: 'relative'
        }}
        className="top-log-2"
      >
        <button onClick={() => setOpen(true)} className="open-btn">
          <div className="line-toggle"></div>
          <div className="line-toggle"></div>
          <div className="line-toggle"></div>
        </button>
        <div style={{ marginLeft: '20px' }}>
          <Link to={`/${ugr}/client/home-page`} style={{ textDecoration: 'none' }}>
            <div className="roboto-regular logo-name" style={Logostyle}>
              <span style={{ fontSize: '40px' }} className="roboto-medium">
                W
              </span>
              illiams Sonoma <span className="roboto-light">Home</span>
            </div>
          </Link>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px 0'
          }}
          className="my-activity"
        >
          <div
            style={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
            onClick={() => navigate(`/${ugr}/client/my-activity`)}
          >
            <span className="material-symbols-outlined" style={{ cursor: 'pointer' }}>
              monitoring
            </span>
            <span className="roboto-regular" style={{ fontSize: '12px' }}>
              My Activity
            </span>
          </div>
        </div>
      </div> */}
      <Stack
        direction="row"
        justifyContent="space-between"
        style={{
          padding: '15px 20px',
          borderBottom: '1px solid lightGrey',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          background: '#fff'
        }}
        className="nav-list-menu"
      >
        {/* <Link to={`/${ugr}/client/home-page`}> */}
        <img src={`${globalIP}${companyDetails.logo}`} style={{ width: '60px' }} />
        {/* </Link> */}
        {companydata == 'Domestic' ? (
          <>
            <ul
              style={{ display: 'flex', padding: 0 }}
              className="nav-list-items"
              onMouseLeave={() =>
                setActiveItem(
                  getCurrentPageName == 'HomePage'
                    ? 0
                    : getCurrentPageName == 'ProductPage'
                    ? 1
                    : getCurrentPageName == 'Visual'
                    ? 3
                    : null
                )
              }
            >
              <li
                className={activeItem === 0 ? 'active' : ''}
                onMouseEnter={() => handleMouseEnter(0)}
                onMouseLeave={handleMouseLeave}
              >
                <Link to={`/${ugr}/client/product`}>My Catalogue</Link>
              </li>
            </ul>
          </>
        ) : (
          <>
            <ul
              style={{ display: 'flex', padding: 0 }}
              className="nav-list-items"
              onMouseLeave={() =>
                setActiveItem(
                  getCurrentPageName == 'HomePage'
                    ? 0
                    : getCurrentPageName == 'ProductPage'
                    ? 1
                    : getCurrentPageName == 'Visual'
                    ? 3
                    : null
                )
              }
            >
              {/* <li
                className={activeItem === 0 ? 'active' : ''}
                onMouseEnter={() => handleMouseEnter(0)}
                onMouseLeave={handleMouseLeave}
              >
                <Link to={`/${ugr}/client/home-page`}>Home Page</Link>
              </li> */}
              <li
                className={activeItem === 1 ? 'active' : ''}
                onMouseEnter={() => handleMouseEnter(1)}
                onMouseLeave={handleMouseLeave}
              >
                <Link to={`/${ugr}/client/product`}>My Catalogue</Link>
              </li>

              {/* <li
                className={activeItem === 2 ? 'active' : ''}
                onMouseEnter={() => handleMouseEnter(2)}
                onMouseLeave={handleMouseLeave}
              >
                <Link to={`/${ugr}/client/home-page`}>New Collections</Link>
              </li> */}
              {isShowButtons.visualProduct && (
                <li
                  className={activeItem === 3 ? 'active' : ''}
                  onMouseEnter={() => handleMouseEnter(3)}
                  onMouseLeave={handleMouseLeave}
                >
                  <Link to={`/${ugr}/client/space-visualization`}>Space Visualization</Link>
                </li>
              )}
              <li
                className={activeItem === 4 ? 'active' : ''}
                onMouseEnter={() => handleMouseEnter(4)}
                onMouseLeave={handleMouseLeave}
              >
                <Link size="sm" onClick={() => handleOpenM('xs')}>
                  Contact Us
                </Link>
              </li>
              {/* )} */}
            </ul>
          </>
        )}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px 0'
          }}
          className="my-activity"
        >
          <div
            style={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
            onClick={() => navigate(`/${ugr}/client/my-activity`)}
          >
            <span className="material-symbols-outlined" style={{ cursor: 'pointer' }}>
              monitoring
            </span>
            <span className="roboto-regular" style={{ fontSize: '12px' }}>
              My Activity
            </span>
          </div>
        </div>
      </Stack>
      <NavDrawer open={open} close={() => setOpen(false)} />

      <Outlet />
      <Modal size="sm" open={openM} onClose={handleCloseM}>
        <Modal.Header>
          <Modal.Title>Contact Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Divider style={{ marginTop: '0px' }} />
          <div style={{ textAlignLast: 'center' }}>
            <p style={{ fontSize: '20px' }}>
              <strong>{parsedData?.attributes?.Full_Name || 'N/A'}</strong>{' '}
            </p>
            <p style={{ color: 'rgb(163 161 161)' }}>{companyDetails.companyName || 'N/A'}</p>
            <p>
              <span style={{ color: 'rgb(163 161 161)' }}>
                {' '}
                <PhoneFillIcon color="#c29100" style={{ marginRight: '5px', fontSize: '18px' }} />
                Mobile No:
              </span>{' '}
              {parsedData?.attributes?.MobileNo || 'N/A'}
            </p>
            <p>
              <span style={{ color: 'rgb(163 161 161)' }}>
                <GlobalIcon color="#c29100" style={{ marginRight: '5px', fontSize: '18px' }} />
                Website:
              </span>{' '}
              <span style={{ color: '#c29100' }}>{companyDetails.website || 'N/A'}</span>
            </p>
            <p>
              <span style={{ color: 'rgb(163 161 161)' }}>
                <EmailFillIcon color="#c29100" style={{ marginRight: '5px', fontSize: '18px' }} />
                Email:
              </span>{' '}
              {parsedData?.attributes?.Email_Id || 'N/A'}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseM} appearance="primary">
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const headerstyle = {
  fontSize: '15px',
  textTransform: 'capitalize',
  letterSpacing: '.05rem'
};
const Logostyle = {
  fontSize: '32px',
  textTransform: 'capitalize',
  letterSpacing: '.07rem',
  color: '#005c80'
};

export default Header;
